import { WarrantyModel, TextNumberModel, QuoteModel, TextTaskModel, RegionModel } from '.'
import { GeoPositionModel } from '~/models/geoposition'
import {
  BaseModel,
  convertToArrayModels,
  convertToModel,
  fillOwnProperties,
  registerModel,
} from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { cropImage, toCroppedImage } from '~/shared/utils/image'
import { ArticleMainItem } from '~/models/articles'
import { VideoModel } from '~/models/video'
import { VideoCardModel } from '~/models/cards'
import { EmployersTasksListItemModel } from '~/models/employers-tasks'

// eslint-disable-next-line @typescript-eslint/naming-convention
export type requestStatus = 'NEW' | 'MODERATION' | 'APPROVED' | 'PUBLISHED' | 'REJECTED'

export default class Employer extends BaseModel {
  static override constructorName = 'Employer'

  public id: number = 0
  public name: string = ''
  public slug: string = ''
  public description: string = ''
  public companyDescription: string = ''
  public editRequestStatus: requestStatus = 'NEW'
  public link: string = ''
  public logo: string | File[] = []
  public image: string | File[] = []
  public imageGeo: string = ''
  public companySlogan: string = ''
  public vacanciesCount: number = 0
  public internshipsCount: number = 0
  public mainVideo: VideoModel = new VideoModel({})
  public digitalLectureVideos: Array<VideoCardModel> = []
  public tasks: Array<TextTaskModel> = []
  public regions: Array<RegionModel> = []
  public video: Array<VideoModel> = []
  public geoPositions: Array<GeoPositionModel> = []
  public news: Array<ArticleMainItem> = []
  public sliderImages: Array<string> | File[] = []
  public warranties: Array<WarrantyModel> = []
  public numbers: Array<TextNumberModel> = []
  public requirements: Array<string> = []
  public quotes: Array<QuoteModel> = []
  public assignments: Array<EmployersTasksListItemModel> = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (data.company_slogan === null) {
        this.companySlogan = ''
      }

      if (Array.isArray(data.regions)) {
        this.regions = data.regions.map(i => new RegionModel(i.region))
      }

      this.video = convertToArrayModels(data.video, VideoModel)
      this.digitalLectureVideos = convertToArrayModels(data.digital_lecture_videos, VideoCardModel)
      this.geoPositions = convertToArrayModels(data.text_geo, GeoPositionModel)
      this.news = convertToArrayModels(data.news, ArticleMainItem)
      this.numbers = convertToArrayModels(data.text_numbers, TextNumberModel)
      this.assignments = convertToArrayModels(data.assignments, EmployersTasksListItemModel)

      if (Array.isArray(data.text_requirements)) {
        data.text_requirements.forEach(i => {
          if (isUnknownObject(i) && typeof i.text === 'string') {
            this.requirements.push(i.text)
          }
        })
      }

      this.quotes = convertToArrayModels(data.employer_quotes, QuoteModel)

      if (Array.isArray(data.slider_image)) {
        this.sliderImages = data.slider_image.map(i => {
          if (typeof i === 'string') {
            return cropImage(i, {})
          }
          return i
        })
      }

      this.warranties = convertToArrayModels(data.text_warranty, WarrantyModel)
      this.tasks = convertToArrayModels(data.text_tasks, TextTaskModel)

      this.mainVideo = convertToModel(data.main_video, VideoModel, new VideoModel({}))

      this.logo = toCroppedImage(data.logo)
      this.image = toCroppedImage(data.image)
      this.imageGeo = toCroppedImage(data.imageGeo)
    }
  }
}

registerModel(Employer)
